/* Nema Firenze - Touch support for diagonal veil reveal */
(function() {
  'use strict';
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) return;

  var blocks = document.querySelectorAll('.section--full-width .group-block');
  if (!blocks.length) return;

  blocks.forEach(function(block) {
    var hasImage = block.querySelector('.background-image-container img');
    if (!hasImage) return;

    block.addEventListener('touchstart', function(e) {
      // If already revealed, let the default link behavior happen
      if (block.classList.contains('revealed')) return;

      // First tap: reveal the image, prevent navigation
      e.preventDefault();
      // Close any other revealed blocks
      blocks.forEach(function(b) { b.classList.remove('revealed'); });
      block.classList.add('revealed');
    }, { passive: false });
  });

  // Tap outside closes all reveals
  document.addEventListener('touchstart', function(e) {
    var insideBlock = e.target.closest('.section--full-width .group-block');
    if (!insideBlock) {
      blocks.forEach(function(b) { b.classList.remove('revealed'); });
    }
  }, { passive: true });
})();
